import { handleJsonResponse, requestGet, SERVICE_URL } from 'util/request';

export const fetchStateGeometry = (stateId: string, countryId: string) =>
  requestGet(`${SERVICE_URL}/state_geometry_v2/?state=${stateId}&country=${countryId}`).then(
    handleJsonResponse,
  );

export default fetchStateGeometry;
